/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2015, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */

// Module to make the jQuery library/api injectable.
angular.module('jquery', [])
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  .factory('$', ['$window', jQueryFactory]);

function jQueryFactory($window) {
  return $window.$;
}
